<!-- 배경 이미지 -->
<div class="relative w-full">
  <img src="/inquiry/inquiry-bg-mo.svg" alt="top background" class="w-full flex lg:hidden" />
  <img src="/inquiry/inquiry-bg-pc.png" alt="top background" class="w-full hidden lg:flex" />

  <div class="absolute inset-0 flex flex-col justify-center gap-3 pt-14 px-4 lg:px-0 lg:container">
    <h1 class="text-white text-2xl lg:text-4xl font-bold">제휴 문의</h1>
    <p class="text-zinc-300 font-medium">Partnership Inquiry</p>
  </div>
</div>

<section class="flex flex-col w-full max-w-6xl mx-auto py-8 lg:py-15 gap-8 lg:gap-15 px-4 lg:px-0">
  <div class="flex flex-col lg:flex-row gap-6 lg:gap-15">
    <div class="flex flex-col gap-3 justify-start lg:min-w-[320px]">
      <h1 class="text-zinc-800 text-xl font-semibold">
        소통과 가치창조로<br />
        고객과 함께 미래를 선도합니다
      </h1>
      <p class="text-zinc-500 font-medium text-base">
        문의를 남겨주시면 담당자가 확인 후 빠르고 신속하게<br class="hidden lg:flex" />답변드리겠습니다.
      </p>
    </div>

    <form [formGroup]="form" class="w-full">
      <div class="flex flex-col gap-6">
        <div class="flex flex-col gap-6 border border-zinc-100 rounded-2xl p-5 bg-white">
          <app-fieldset label="이름" required>
            <input type="text" formControlName="name" class="input w-full" placeholder="입력해주세요" />
          </app-fieldset>

          <app-fieldset label="연락처" required>
            <input
              type="text"
              formControlName="contact"
              appFormatInput="phone"
              placeholder="010-1234-5678"
              maxlength="13"
              class="input w-full" />
          </app-fieldset>

          <app-fieldset label="제목" required>
            <input type="text" formControlName="title" class="input w-full" placeholder="입력해주세요" />
          </app-fieldset>

          <app-fieldset class="relative" label="문의내용" required>
            <textarea
              formControlName="content"
              class="input w-full min-h-25"
              placeholder="입력해주세요"
              maxlength="1000"
              style="white-space: normal"></textarea>
            <div class="absolute bottom-4 right-2 text-sm text-zinc-300 z-10">
              {{ form.controls.content.value.length }}/1000
            </div>
          </app-fieldset>
          <button
            type="button"
            (click)="submitInquiry()"
            [disabled]="form.invalid"
            class="cursor-pointer flex-1 bg-primary-500 font-medium text-white rounded-lg p-3 lg:py-2 lg:px-3 disabled:bg-zinc-200 disabled:cursor-not-allowed">
            문의하기
          </button>
        </div>
      </div>
    </form>
  </div>
</section>
